import ScribeSetThemeColor from './ScribeSetThemeColor';
export default ScribeSetThemeColor;
